import { z } from 'zod';
import { PERMISSION_KEYS, PERMISSION_SCOPES, type PermissionKey } from '../permissions';
import { objectIdSchema, optionalText, paginationQuerySchema, passwordSchema, patchOf, requiredEmail } from './common';
import { USER_STATUSES } from '../constants';

const permissionKey = z.enum(PERMISSION_KEYS as [PermissionKey, ...PermissionKey[]]);

export const grantSchema = z.object({
  key: permissionKey,
  scope: z.enum(PERMISSION_SCOPES).default('all'),
});

export const roleCreateSchema = z.object({
  name: z.string().trim().min(2).max(60),
  description: optionalText(300),
  grants: z.array(grantSchema).max(200),
});
export type RoleCreateInput = z.input<typeof roleCreateSchema>;

export const roleUpdateSchema = patchOf(roleCreateSchema);

export const overrideSchema = grantSchema.extend({ effect: z.enum(['allow', 'deny']) });

export const userAccessUpdateSchema = z.object({
  roleIds: z.array(objectIdSchema).min(1).max(10).optional(),
  overrides: z.array(overrideSchema).max(100).optional(),
});

export const userStatusSchema = z.object({
  status: z.enum(USER_STATUSES),
  reason: optionalText(300),
});

export const userCreateSchema = z.object({
  name: z.string().trim().min(2).max(100),
  email: requiredEmail(),
  temporaryPassword: passwordSchema,
  roleIds: z.array(objectIdSchema).min(1).max(10),
  employeeId: objectIdSchema.nullable().optional(),
});
export type UserCreateInput = z.input<typeof userCreateSchema>;

export const userListQuerySchema = paginationQuerySchema.extend({
  status: z.enum(USER_STATUSES).optional(),
  roleId: objectIdSchema.optional(),
  kind: z.enum(['internal', 'client']).optional(),
});

export const adminResetPasswordSchema = z.object({
  temporaryPassword: passwordSchema,
});
